const jp = {
  登录: "ログイン",
  注册: "登録",
  申请卡片: "カード申請",
  USDT区块链: "ブロックチェーン × ",
  数字货币与传统金融的跨界交融:
    "暗号通貨と伝統的な金融の融合",
  "创新性金融整合应用体，财富跨界安全自由":
    "安全かつ自由な資産管理を国境を超えて実現する、革新的な金融プラットフォーム",
  核心功能: "コア機能",
  全球提现: "世界で使える出金機能",
  "全球275个地区与国家的实体卡自由提现服务。从容面对，安全体验":
    "世界200以上の国と地域で、実体カードによる引き出しサービスを提供。安心・安全な体験をお楽しみください。",
  全球消费: "世界で買い物",
  "撒欢自在，从现在开始，做你想做的事":
    "もっと自由に、もっと楽しく。あなたの「やりたい」を思いのままに。",
  账户管理: "アカウント管理",
  "开卡、充值、冻结、注销操作尽在掌控，体验拉满，事事安心":
    "カードの発行、チャージ、一時停止、解約など、すべての操作を自在に管理。充実した機能で、あらゆる場面に安心をお届けします。",
  虚实互动: "バーチャルとリアルのインタラクション",
  "虚拟VCC快速开卡，时时掌控，快速消费数字USDT极速转换，刻刻转换，跨界便捷":
    "バーチャルVCCでのカード開設が迅速で、常時コントロールでき、デジタルUSDTの高速変換で、迅速に消費でき、クロスボーダーが便利です",
  支持: "完全対応",
  "真实感受区块链货币与现实货币的无限可能!是USDT也是您手握的现金":
    "暗号通貨と実通貨の境界を越える無限の可能性をあなたに。あなたのUSDTはもはや単なるデータではなく、手元の現金と同じように使えます。",
  随时随地的全球消费: "いつでも、どこでも、世界中で買い物を",
  "从现在开始，享受非凡的优质消费体验":
    "これからは、ワンランク上の決済体験をお楽しみください",
  "支持全球范围的无限支持全球商户的无限制消费，任何时间任何地点制消费，走到哪里都不怕":
    "世界の加盟店で利用可能：いつでもどこでも、場所を選ばずにお支払い。どこへ行っても心配はいりません",
  "数字货币快速转换，真金白银时时到账":
    "暗号通貨を瞬時に変換：暗号通貨を素早く両替し、いつでもすぐに利用可能",
  "真金白银时时到账是陌生的领域，也是您熟悉的家园，一卡通全球":
    "一枚のカードで、世界中へ：初めて訪れる国でも、普段と同じような快適さを。いつでも資金が手元にある安心感と共に、世界中を旅しましょう",
  无界卡: "ボーダレスカード",
  "24小时贴身顾问服务，专属秘书服务":
    "24時間体制のパーソナルコンサルタントサービスと専属秘書サービス",
  "专业出行行程规划、机票、餐饮、旅行、全方位的专属服务":
    "専門的な出張行程計画、航空券、飲食、旅行、全方位的な専属サービス",
  "高端专属私密社交互动，人脉拓展的便捷通道":
    "ハイエンド専属のプライベートソーシャルインタラクション、人脈拡大の便利なチャネル",
  "私人预定服务，高端会所、食所、专属预约":
    "プライベート予約サービス、ハイエンドクラブ、飲食店、専属予約",
  "游艇、私人飞机、豪车预定服务，我们搞定所有，您尽情享受":
    "ヨット、プライベートジェット、高級車の予約サービスは、私たちがすべて手配しますので、存分にお楽しみください",
  "特别后端支撑服务，全面用卡体验":
    "特別なバックエンドサポートサービスで、カード使用の全面的な体験を提供します",
  "7x24小时在线贵宾服务": "7x24時間オンラインVIPサービス",
  "全年无休，提供7X24小时的在线服务，周年纪念日、办公聚餐、商务旅行及私人旅行定制等全方位的卡片福利礼遇服务":
    "年中無休で、7X24時間のオンラインサービスを提供し、記念日、オフィス会食、ビジネス旅行及びプライベート旅行のカスタマイズなど、全方位のカード特典と礼遇サービスを提供します",
  线上线下的高水准使用: "オンラインとオフラインの高水準な使用",
  "线上线下的全覆盖使用体验，ApplePay、GooglePAY、PayPay等全线上绑卡消费，同步支持线下无卡消费场景":
    "オンラインとオフラインの全カバー使用体験で、ApplePay、GooglePAY、PayPayなどの全オンラインカード紐付け消費をサポートし、同時にオフラインのカードレス消費シーンもサポートします",
  Visa及Master顶级支持: "Visa及びMasterのトップレベルサポート",
  "全球两大顶级卡组支持，可在世界大部分地区使用，体验无与伦比的地位":
    "世界の二大トップレベルカードグループのサポートで、世界の大部分の地域で使用でき、比類なき地位を体験できます",
  本地及海外顶级酒店预定: "国内及び海外のトップホテル予約",
  "无论在本地还是海外，超过千家住宿酒店中，您可享受优先预定、客房升级、免费早餐、提前入住、延迟退房等各种优惠服务":
    "国内でも海外でも、千軒以上の宿泊ホテルで、優先予約、客室アップグレード、無料朝食、早期チェックイン、遅延チェックアウトなどの様々な特典サービスをお楽しみいただけます",
  免费机场出行休息厅服务: "無料空港出発ラウンジサービス",
  "免费出行特权，可使用多个国家和地区超过高达600城市的1500多个机场及出行场所":
    "無料の出発特権で、多くの国と地域の600以上の都市の1500以上の空港及び出発場所を利用できます",
  豪华酒店及高端餐饮服务: "豪華ホテル及びハイエンド飲食サービス",
  "提过优质的VIP待遇，可享受优先预定高端特殊餐饮的预定服务":
    "質の高いVIP待遇を提供し、ハイエンド特殊飲食の優先予約サービスをお楽しみいただけます",
  专属vip特殊通道服务: "専属VIP特殊チャネルサービス",
  "通过kdcard，可支持预定特殊场所的服务，无需担心，KdCard可以帮助您完成高端会员制会所及非开放式招待场所的特殊预约服务":
    "kdcardを通じて、特殊な場所の予約サービスをサポートできます。心配する必要はありません。KdCardはハイエンド会員制クラブ及び非オープン式接待場所の特殊予約サービスを完了するのをお手伝いできます",
  专享非公众开放的独家福利: "一般公開されていない独占的な特典を専有できます",
  "通过卡片，可专享独家福利待遇，我们将提供私密专属高端场所预定、部分限量发行商品的优先购买权、预售及特殊活动邀请等独家福利":
    "カードを通じて、独占的な特典待遇を専有できます。私たちはプライベート専属のハイエンド場所の予約、一部の限定発行商品の優先購入権、プレセール及び特殊イベントへの招待などの独占的な特典を提供します",
  首年年费减免: "初年度年会費減免",
  "申卡首年年费减免服务，通过超优惠政策，现在申卡，可100%享受首年年费减免服务":
    "カード申請初年度年会費減免サービスで、超優遇政策を通じて、今カードを申請すると、初年度年会費減免サービスを100％享受できます",
  专属服务: "あらゆる場面に対応",
  "卡片专属福利服务，出行、商务、旅游、住宿，精彩横生包罗万象":
    "旅行、ビジネス、観光、宿泊、日常のお買い物など、オンライン・オフラインを問わず全ての場面をカバー。ネットでも街中でも、国境を越えてあらゆる支払いに対応します。豊富な機能がもたらす、シームレスで素晴らしい決済体験をあなたに。",
  年费: "年会費",
  "金卡：350 美金": "ゴールドカード：350 ドル",
  "白金卡：760美金": "プラチナカード：760 ドル",
  "黑金卡：1500美金": "ブラックカード：1500 ドル",
  开年卡首年达标免年费: "カード開設初年度の達成基準による年会費免除",
  附加卡: "追加カード",
  家庭卡免费x2: "ファミリーカード無料×2",
  公司卡免费x2: "会社カード無料×2",
  转U费用: "Uへの転送費用",
  "1+1美金/笔": "1 + 1 ドル/取引",
  充值费用: "チャージ費用",
  "2%/笔": "2%/取引",
  支持品牌: "サポートブランド",
  发卡时限: "カード発行期限",
  VCC申请后2小时内: "VCC申請後2時間以内",
  年龄限制: "年齢制限",
  "20岁以上群体": "20歳以上のグループ",
  特定增值: "特定の付加価値",
  服务: "サービス",
  根据卡类享受不同的特定福利:
    "カードの種類によって異なる特定の特典を享受できます",
  申请步骤介绍: "申請ステップの紹介",
  "您仅需享受最快10分钟申请 立即拥有输你的自己的WFFCard":
    "最短10分の申請で、あなただけのWFFCardを持つことができます",
  "申请前务必核对申请条件及基础信息!":
    "",
  "在线会员申请，注册1分钟": "オンライン会員登録からカード発行に必要な情報の入力まで、スピーディーに完結します。",
  "完成会员申请后开卡，开卡填写资料最长5分钟":
    "",
  分钟: "分間",
  "将USDT转入钱包，增加自己的数字资产":
    "USDTをウォレットに入金し、暗号通貨をチャージしましょう。",
  "（请根据需求，量力而行）":
    "（ご自身の利用目的と経済状況に合わせて、無理のない範囲でご利用ください）",
  "申请开卡，选择您希望的品牌卡片（visa":
    "カード開設を申請し、あなたが望むブランドのカード（visa",
  "或master），将USDT转入卡内转变为消":
    "またはmaster）を選択し、USDTをカードに転送して消費額に変換します",
  "费额度（此操作可重复进行，可逆向操":
    "費用額（この操作は繰り返し行うことができ、逆方向の操作も可能です）",
  "作，U转卡2%-3%费用，卡转回U免费）":
    "操作で、Uからカードへの転送には2％ - 3％の費用がかかり、カードからUへの転送は無料です）",
  立即开卡: "カードを申請する",
  语言: "言語",
  支付产品: "支払い製品",
  线下支付: "オフライン支払い",
  线上支付: "オンライン支払い",
  关于我们: "私たちについて",
  USDT支持: "USDTサポート",
  收费标准: "料金標準",
  网上支付: "オンライン支払い",
  联系我们: "お問い合わせ",
  常见问题: "よくある質問",
  faq: "デビットカードQ&A",
  网站使用条款: "ウェブサイト利用規約",
  Cookie声明: "Cookieステートメント",
  立即下载: "今すぐダウンロード",
  跨境线上消费模式: "国際的な決済サービス",
  "世界有多大，心就有多大，支持绑定多电子支付场景，GooglePlay、AppStore、Steam、 Amazon. 全宇宙都是你的消费乐园!":
    "広がる世界、広がる体験。実店舗でもオンラインでも、幅広くご利用いただけます。Google PlayやApp Store、Steam、Amazonなど、様々なデジタル決済サービスとスムーズに連携できます。オンラインの世界も、あなたの自由なショッピングエリアに。",
  费率及费用介绍: "料率及び費用の紹介",
  用户协议: "利用規約",
  隐私协议: "プライバシーポリシー",
  账户删除声明: "アカウント解約規定",
  激活指南: "アクティベーションガイド",
  首页: "ホーム",
  步骤三:
    "カードの発行を申請します（現在はVisaに対応。Mastercardなどは順次対応予定）。 USDTをカードにチャージすると、すぐに買い物に使える残高として反映されます。",
  查看: "詳しくはカード発行に関する案内をご確認ください",

"Step":"手順",
"Select Language":"言語を選択",
"Card Activation Guide":"カード活性化ガイド",
"Scan the QR code, register and log in to your account. For your first login, you need to complete KYC verification, and only after completing KYC verification can you activate the card.":"QR コードをスキャンし、登録後にアカウントにログインしてください。初回ログイン時には KYC 認証を完了させる必要があり、KYC 認証完了後にのみカードの活性化が可能となります。",
"Tap the 'Card' button at the bottom to enter the Card List page. On the Card List page, tap 'Apply for Card' to start the card application process.":"下部の「カード」ボタンをタップし、カードリスト画面に入ります。カードリスト画面で「カード申請」をタップすると、カード発行手続きに進みます。",
"After entering the card activation page, select 'Get Card Now' under 'Physical Card' to start the physical card activation process.":"カード発行画面に入った後、「実体カード」の下にある「すぐカードを取得」を選択し、実体カードの発行手続きに進みます。",
"During the physical card issuance process, select 'Yes, I have already received the physical card', tap 'Create Card' below to enter the physical card activation page. Enter your card number to obtain the activation code— the system will send the code to your email address. Input the activation code and tap 'Activate Now' to complete the activation.":"実体カードの発行手続き中に「はい、実体カードはもうもらいました」を選択し、下部の「すぐにカード発行」をタップして実体カードの活性化画面に進みます。カード番号を入力して活性化コードを取得し、システムからご本人のメールアドレスに活性化コードを送信します。活性化コードを入力し、「すぐ活性化」をタップすると、活性化が完了します。",
"After the card is successfully activated, tap Return to Card List'. You can view and manage your card in the Card List.":"カードの活性化が成功した後、「カードリストに戻る」をタップします。カードリストでカードの確認と操作ができます。"
};
export default jp;
